import React from 'react'
import { FaTelegramPlane, FaYoutube } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'

export default function LandingPage() {
    return (
        <>
            <div className='landing-bg'>
                <p className='text-center landing-text'>Hamster Kombat Token</p>
                <p className='text-center landing-text-center'>will be launched</p>
                <h1 className='text-center landing-text-bottom'>on TON</h1>
            </div>

            <div>
                <b className='text'>Stay tuned</b>
                <b className='text-info-landing'>More info in official channels</b>
            </div>

            <div className='icons'>
                <div>
                    <FaTelegramPlane className='telegram-icon' />
                </div>
                <div>
                    <FaYoutube className='telegram-icon mx-3' />
                </div>
                <div>
                    <FaXTwitter className='telegram-icon' />
                </div>
            </div>
        </>
    )
}
